import { Text } from 'foundations-components/components/Text';
import ErrorSectionFormatter from './internal/ErrorSectionFormatter';
import ActionSectionFormatter from './internal/ActionSectionFormatter';
import HtmlSectionFormatter from './internal/HtmlSectionFormatter';
import { stripHtml } from '../CopilotPreview/internal/utils/Messages';
import { useShouldShowActions } from '../../hooks/useShouldShowActions';
import { jsx as _jsx } from "react/jsx-runtime";
export const STANDARD_UNSUPPORTED_TYPES = ['DATA_TABLE', 'MEDIA', 'THOUGHT', 'ACCORDION', 'CARD', 'IMAGE_GRID', 'MEDIA_V2'];
export const GENERATE_CONTENT_UNSUPPORTED_TYPES = [...STANDARD_UNSUPPORTED_TYPES, 'ACTION'];
/** Component only supports displaying plain text and action buttons */
const SimpleMessageSection = ({
  section,
  onQuickActionClick,
  usageTracker,
  unsupportedTypes = STANDARD_UNSUPPORTED_TYPES
}) => {
  const shouldShowActions = useShouldShowActions();
  if (unsupportedTypes.includes(section.type)) {
    return null;
  } else if (section.type === 'HTML' || section.type === 'LLM') {
    return /*#__PURE__*/_jsx(HtmlSectionFormatter, {
      section: section
    });
  } else if (section.type === 'PLAIN_TEXT') {
    const plainText = stripHtml(section.text);
    return /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      children: plainText
    });
  } else if (section.type === 'ACTION') {
    if (shouldShowActions) {
      return /*#__PURE__*/_jsx(ActionSectionFormatter, {
        section: section,
        onClick: onQuickActionClick,
        usageTracker: usageTracker
      });
    } else {
      return null;
    }
  }
  return /*#__PURE__*/_jsx(ErrorSectionFormatter, {});
};
export default SimpleMessageSection;